import {
  WSButton,
  WSCard,
  WSText,
  WSTimeline
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";

import {
  getImportBatchTimelineItems,
  ImportBatchTimelineArgs
} from "./getImportBatchTimelineItems";

const RECENT_HISTORY_ITEMS_COUNT = 4;

type Props = Omit<ImportBatchTimelineArgs, "showDetailedContent">;

/** The last few batch milestones, with a way through to the full history. */
export const ImportBatchEventHistoryWidget: React.FC<Props> = props => {
  const timelineItems = useMemo(() => {
    const items = getImportBatchTimelineItems(props);
    const recentItems = items.slice(0, RECENT_HISTORY_ITEMS_COUNT);

    if (items.length > RECENT_HISTORY_ITEMS_COUNT) {
      recentItems.push({
        content: (
          <WSButton.Link onClick={props.onSeeMore}>
            View all history and details
          </WSButton.Link>
        )
      });
    }

    return recentItems;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.batch, props.itemCount, props.completedCount, props.failedCount]);

  return (
    <WSCard
      header={{
        label: { text: "Recent history" },
        value: {
          ...(timelineItems.length > 0 && {
            action: { label: "View all", onClick: props.onSeeMore }
          })
        }
      }}
      divider
    >
      {timelineItems.length === 0 ? (
        <WSText.ParagraphSm color="gray400" align="center">
          No history available
        </WSText.ParagraphSm>
      ) : (
        <WSTimeline items={timelineItems} />
      )}
    </WSCard>
  );
};
